import React, { ReactNode } from 'react'

interface ExpenseDetailsItemProps {
  title: string
  value: string
  className?: string
  icon?: ReactNode
}

const ExpenseDetailsItem: React.FC<ExpenseDetailsItemProps> = ({ title, value, className, icon }) => {
  return (
    <div className={`expense_details_item ${className}`}>
      <h6 className="section_title">{title}</h6>
      <div className="section_value">
        {icon ? icon : null}
        <h6>{value}</h6>
      </div>
    </div>
  )
}

export default ExpenseDetailsItem
